import { fetchClient } from '@nike/fetch-client';
import { DOTCOM_UX_ID } from '@nike/ux-tread-dotcom-constants';
export var API_DOMAIN = 'https://api.nike.com';
var defaultOptions = {
  host: API_DOMAIN,
  uxId: DOTCOM_UX_ID
};
/**
 * fetchUser lets you directly fetch the data from
 * identity api. However this usage should be deprecated
 * in favor of window.nike.unite's methods per Unite team.
 *
 * @param  {string} token -     derived from unite sdk getCredential
 * @returns {object}           user data
 */

export function fetchUserData(token) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOptions,
      _ref$host = _ref.host,
      host = _ref$host === void 0 ? API_DOMAIN : _ref$host,
      upmId = _ref.upmId,
      _ref$uxId = _ref.uxId,
      uxId = _ref$uxId === void 0 ? DOTCOM_UX_ID : _ref$uxId;

  return fetchClient("".concat(host, "/identity/user/v1/").concat(upmId, "/address"), {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
      'x-nike-ux-id': uxId,
      Authorization: "Bearer ".concat(token)
    }
  }, 'Error fetching user data.', {
    pageActionName: 'tread-identity'
  });
}